import React from 'react';
//import { Link } from 'react-router-dom';

import HomePrd from './../../components/HomePrd';
import Footer from '../Footer';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import Schnider from './../../assets/Schnider_logo.webp';
import Solar from './../../assets/solarbg3-portrait.jpg';
import BrandSlide from '../BrandSlides';


import './styles.scss';
import { Link } from 'react-router-dom';
import Slideshow from '../Slideshow';

//bootstrap
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';

//lottie
import Lottie from 'lottie-react-web'
import animation1 from './../../assets/animation1.json'
import animation2 from './../../assets/animation2.json'
import animationabout from './../../assets/animation-about.json'


const Directory = props => {
  return (
    <div className="directory">

      <div className='dir-container'>
        <Row className='row1'>
          <Col>
            <h1>The Nature of Wind <br />And Sun Gives <br />Clean Energy</h1>
            <h2> Sustainable Power Supply</h2>
            <p>The Wind Stays Forever, The Sun Stays Forever, Solar Enery Stays Forever</p>
          </Col>

          <Col className='lottie'>
            <Lottie
              options={{
                animationData: animation1
              }}
            />
          </Col>
        </Row>

        <Row className='row2'>
          <h2 className='head'> OUR OFFER </h2>
          <h2>We offer different services</h2>
          <p>We don’t want to melt the polar, so we should all use solar and With Solar Panels the future is looking bright.
            Use free and green energy from sun.</p>

        </Row>

        <Row className='row1'>
          <Col className='lottie'>
            <Lottie
              options={{
                animationData: animation2
              }}
            />
          </Col>

          <Col>
            <h1> Say No To <br /> Power Interuption</h1>
            <h2> Solar Energy Enables Comfortability</h2>
            <p>Our services are with high standard and at affordable reasonable price. Hence, without deviating from our professional standard in terms of quality service delivery.</p>
          </Col>
        </Row>

        <Row className='cards'>
          <Card>
            <Card.Img variant="top" src={Schnider} />
            <Card.Body>
              <Card.Title>
                Energy Efficiency Consultation
              </Card.Title>

              <Button>
                Book Now
              </Button>
            </Card.Body>
          </Card>

          <Card>
            <Card.Img variant="top" src={Schnider} />
            <Card.Body>
              <Card.Title>
                Energy Efficiency Consultation
              </Card.Title>

              <Button>
                Book Now
              </Button>
            </Card.Body>
          </Card>

          <Card>
            <Card.Img variant="top" src={Schnider} />
            <Card.Body>
              <Card.Title>
                Energy Efficiency Consultation
              </Card.Title>

              <Button>
                Book Now
              </Button>
            </Card.Body>
          </Card>
        </Row>


        <Row className='about-us'>
          <Col className='lottie'>
            <Lottie
              options={{
                animationData: animationabout
              }}
            />
          </Col>
          <Col className='about-us-content'>
            <h2>About Us</h2>
            <p>Solar Scientist Company Limited is a renowned and active commercial company incorporated by corporate affairs commission (CAC) under the company and allied matters act.
              <br /><br />
              We engage in the business of importation, marketing distribution, installation and maintenance, of solar energy services and alternative power products with a solid capital base and in substantial turnover.
              <br /><br />
              The watchword has been commercialized efficient services and customer’s satisfactory maximization.</p>
          </Col>
        </Row>

        <Row className='row2'>
          <h2 className='head'> WHY CHOOSE US</h2>
          <p>Solar Scientist Company Limited is prepared to give a long-lasting solution to the scenario that have paved way to enormous expenses on fuel purchase and PHCN bills accumulated by individual, corporate organization, non governmental institutions and government institutions in the cause of carrying out their obligations. These costs are inevitable but there is necessity to create an alternative power supply as this will reduce cost of service and alternatively the cost can be diverted to other needful activities.</p>

        </Row>

        <Row className='shop-now-btn'>
          <Button href='/shop'>Shop Now</Button>
        </Row>
      </div>

      <BrandSlide />
    </div>

  );
};

export default Directory;
